export const BOARD_SIZE = 15;
